import $ from 'jquery';

const removeFlagPrefix = () => {
	if ($('div[id^=\'_pre_\']').length === 0) {
		return;
	}

	Array.from($('div[id^=\'_pre_\']'))
		.forEach((element) => {
			element.setAttribute(
				'id',
				element.getAttribute('id').replace('_pre_', ''),
			);
		});
};

const scrollToAnchor = (anchorIdSelector) => {
	removeFlagPrefix();

	if ($(`._link-flag${anchorIdSelector}`).length > 0) {
		$('html, body').animate({
			scrollTop: $(`._link-flag${anchorIdSelector}`).offset().top,
		}, 500, 'linear');
	}
};

export default scrollToAnchor;



// WEBPACK FOOTER //
// ./src/js/scrollToAnchor.js